import { useEffect, useState, useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";
import "./styles.css";
import SignInBox from "./SignInBox";
import useAuth from "../../hooks/useAuth";
import useCustomRouting from "../../hooks/useCustomRouting";
import ThemeToggle from "../ThemeToggle";

const SignInSSO = () => {
  const { redirectToPath } = useCustomRouting();
  const [sessionExpired, setSessionExpired] = useState(false);
  const { token } = useAuth();
  const { isDarkMode } = useContext(ThemeContext);
  useEffect(() => {
    const isExpired = localStorage.getItem("sessionExpired");
    setSessionExpired(isExpired);
    localStorage.removeItem("sessionExpired");
    if (token) {
      redirectToPath("/");
    }
  }, []);

  return (
    <div className="signin-container">
      <img
        className="bg-top-right"
        src={
          isDarkMode
            ? "/ui/images/Truman-UI-bg-signin-top-right-dark-mode.svg"
            : "/ui/images/Truman-UI-bg-signin-top-right.svg"
        }
        alt=""
      />
      <div>
        <img
          className="bg-bottom-left"
          src={
            isDarkMode
              ? "/ui/images/Truman-UI-bg-signin-bottom-left-dark-mode.svg"
              : "/ui/images/Truman-UI-bg-signin-bottom-left.svg"
          }
          alt=""
        />
        <img
          className="bg-bottom-left bg-head"
          src={
            isDarkMode
              ? "/ui/images/Truman-UI-signin-head-dark-mode.svg"
              : "/ui/images/Truman-UI-signin-head.svg"
          }
          alt=""
        />
      </div>
      <SignInBox expired={sessionExpired} />
      <div className="theme-toggle-container">
        <ThemeToggle />
      </div>
    </div>
  );
};

export default SignInSSO;
